import { render, staticRenderFns } from "./BusinessNewsAudienceTargeting.vue?vue&type=template&id=12f8da59&scoped=true&"
import script from "./BusinessNewsAudienceTargeting.vue?vue&type=script&lang=js&"
export * from "./BusinessNewsAudienceTargeting.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNewsAudienceTargeting.vue?vue&type=style&index=0&id=12f8da59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f8da59",
  null
  
)

export default component.exports